import { useMutation } from "@tanstack/react-query";
import React, { useState } from "react";
import { RiCloseLine, RiEyeLine, RiEyeOffLine } from "react-icons/ri";
import { toast } from "react-toastify";
import { updateClientPassword } from "UpdatedFeatures/api";

const ChangePasswordModal = ({ open, setOpen, clientId }) => {
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });
  const ChangeUserPasswordMutation = useMutation({
    mutationFn: (data) => updateClientPassword(data),
    onSuccess: () => {
      toast.success("Mis a jour réussie !");
      setOpen(false)
      setFormData({
        password: "",
        confirmPassword: "",
      });

    },
    onError: (error) => {
      console.log(error)
      toast.error("Une erreur est survenue. Veuillez réessayer.");
    },
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      toast.warn("Les mots de passe ne correspondent pas.");
      return;
    }

    ChangeUserPasswordMutation.mutate({
      client_id: clientId,
      new_password: formData.password,
    });

  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50"
      style={{ zIndex: 9990 }}
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-gray-500 bg-opacity-75"
        aria-hidden="true"
        onClick={() => setOpen(false)}
      />

      {/* Modal Content */}
      <div className="flex items-center justify-center min-h-screen p-4">
        <div
          className="relative w-full max-w-lg mx-auto bg-white shadow-lg rounded-lg overflow-hidden"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="flex justify-between items-center p-6 bg-[#b269ae] border-b border-gray-500/30 pb-4">
            <h3 id="modal-title" className="text-lg font-medium leading-6 text-white">
              Changer le mot de passe
            </h3>
            <button
              type="button"
              className="p-1.5 text-white hover:scale-105 duration-200"
              onClick={() => setOpen(false)}
            >
              <RiCloseLine className="h-6 w-6" />
            </button>
          </div>

          <form className="space-y-4 p-6">
            <div className="grid grid-cols-1 gap-y-4 mt-8">
              {/* Password Field */}
              <div className="relative">
                <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                  Nouveau mot de passe
                </label>
                <input
                  id="password"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  value={formData.password}
                  onChange={handleInputChange}
                  required
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm pr-10 focus:border-[--secondaryColor] focus:ring-[--secondaryColor] sm:text-sm h-12"
                />
                <span
                  onClick={() => setShowPassword((prev) => !prev)}
                  className="absolute top-[38px] right-3 cursor-pointer text-gray-500"
                >
                  {showPassword ? <RiEyeOffLine /> : <RiEyeLine />}
                </span>
              </div>

              {/* Confirm Password Field */}
              <div className="relative">
                <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">
                  Confirmer le mot de passe
                </label>
                <input
                  id="confirmPassword"
                  name="confirmPassword"
                  type={showConfirm ? "text" : "password"}
                  value={formData.confirmPassword}
                  onChange={handleInputChange}
                  required
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm pr-10 focus:border-[--secondaryColor] focus:ring-[--secondaryColor] sm:text-sm h-12"
                />
                <span
                  onClick={() => setShowConfirm((prev) => !prev)}
                  className="absolute top-[38px] right-3 cursor-pointer text-gray-500"
                >
                  {showConfirm ? <RiEyeOffLine /> : <RiEyeLine />}
                </span>
              </div>
            </div>

            {/* Submit Button */}
            <div className="mt-6 flex justify-end">
              <button
                onClick={handleSubmit}
                className="block rounded-md bg-[#b269ae] px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-yellow-300 duration-300"
              >
                {ChangeUserPasswordMutation.isPending ? "Loading.." : "Mettre à jour"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
